import GlobalInteractionSessionTracking from '@atlaskit/analytics-cross-product/globalInteractionSessionTracking';
import { getEnvironment } from '@atlassian/navigation-error-boundary/environment';

export type OpenLoomMeetingRecordingsOptions = {
	bridge: string;
	cloudId: string;
	environment?: 'prod' | 'staging';
	interactionSessionId?: string;
	interactionSource: string;
	loomSource: string;
};

const LOOM_ORIGINS = {
	prod: 'https://www.loom.com',
	staging: 'https://stage.loom.com',
} as const;

const LOOM_AUTH_ORIGINS = {
	prod: 'https://loom.com',
	staging: 'https://stage.loom.com',
} as const;

export const openLoomMeetingRecordings = ({
	bridge,
	cloudId,
	environment,
	interactionSessionId,
	interactionSource,
	loomSource,
}: OpenLoomMeetingRecordingsOptions): WindowProxy | null => {
	const resolvedEnvironment = environment ?? (getEnvironment() === 'prod' ? 'prod' : 'staging');
	const resolvedInteractionSessionId =
		interactionSessionId ??
		GlobalInteractionSessionTracking.getInstance()?.getCurrentInteractionSessionId();

	if (!resolvedInteractionSessionId) {
		throw new Error('Cannot open Loom Meeting Recordings without an interaction session ID.');
	}

	const loomUrl = new URL('/twc/meetings', LOOM_ORIGINS[resolvedEnvironment]);
	loomUrl.searchParams.set('origin', window.location.origin);
	loomUrl.searchParams.set('siteId', cloudId);
	loomUrl.searchParams.set('source', loomSource);
	loomUrl.searchParams.set('state', crypto.randomUUID());
	loomUrl.searchParams.set(
		'xpis',
		window.btoa(
			JSON.stringify({
				bridge,
				id: resolvedInteractionSessionId,
				source: interactionSource,
			}),
		),
	);

	const authUrl = new URL('/api/auth/atlassian', LOOM_AUTH_ORIGINS[resolvedEnvironment]);
	authUrl.searchParams.set('redirect_after', loomUrl.toString());

	return window.open(authUrl.toString());
};
